import { ref } from 'vue'

export type MallToastTone = 'info' | 'success' | 'error'

export interface MallToastItem {
  id: number
  message: string
  tone: MallToastTone
}

const toasts = ref<MallToastItem[]>([])
let seq = 0

function pushToast(message: string, tone: MallToastTone = 'info', ms = 3200) {
  const text = String(message || '').trim()
  if (!text) return
  const id = ++seq
  toasts.value = [...toasts.value, { id, message: text, tone }].slice(-4)
  window.setTimeout(() => {
    toasts.value = toasts.value.filter((item) => item.id !== id)
  }, ms)
}

export function useMallToast() {
  const showToast = (message: string, tone: MallToastTone = 'info') => pushToast(message, tone)
  const showSuccess = (message: string) => pushToast(message, 'success')
  const showError = (message: string | unknown) => {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      pushToast('네트워크 연결이 끊겼습니다. 연결 후 다시 시도해 주세요.', 'error', 4200)
      return
    }
    const text =
      message instanceof Error
        ? message.message
        : typeof message === 'string'
          ? message
          : '요청을 처리하지 못했습니다.'
    pushToast(text || '요청을 처리하지 못했습니다.', 'error', 4200)
  }

  const dismissToast = (id: number) => {
    toasts.value = toasts.value.filter((item) => item.id !== id)
  }

  return { toasts, showToast, showSuccess, showError, dismissToast }
}
